import { Star } from "lucide-react";

export const Stars = ({ value = 5, size = 14 }) => (
  <div className="flex gap-0.5" aria-label={`${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={size}
        strokeWidth={1.5}
        className={i <= value ? "fill-[#0A192F] text-[#0A192F]" : "text-[#C7CBD3]"}
      />
    ))}
  </div>
);
